import DatePicker from "react-datepicker"
import { returnMinDate } from "helpers/helpers"

/** How far back analytics date filters may go (days). */
export const ANALYTICS_DATE_RANGE_DAYS = 365

export default function AnalyticsDatePicker(props) {
	const today = new Date()

	return (
		<div className="calendar-input">
			<DatePicker
				className="form-control"
				dateFormat="dd.MM.yyyy"
				showMonthDropdown
				showYearDropdown
				dropdownMode="select"
				yearDropdownItemNumber={2}
				minDate={returnMinDate(today, ANALYTICS_DATE_RANGE_DAYS)}
				maxDate={today}
				{...props}
			/>
			<i className="uil uil-calendar-alt"></i>
		</div>
	)
}
